import { ControlLayout } from '../Enums/ControlLayout'
import { CustomValidation } from './CustomValidation'
import { ForceDirection } from '../Enums/ForceDirection'
import { Attribute } from './Attribute'
import { TagsInputDTO } from './TagsInputDTO'


export class TagsInputOptions {
    /**
* Represent Name Of Form Control
*/
    Name: string
    /**
  *   Represent classes to tagsinput that allow us to select the AutoComplete by jquery or javascript 
  */

    ExtraClasses: string
  
    /**  Represent value of the label*/
    LabelValue: string
     /**  Represent Key of the label*/
   LabelKey:string
    /**  Represent value of the labelDescription show under tagsinput*/
    LabelDescription: string
    /** Represent value of the Placeholder of tagsinput */
    Placeholder: string
    /**To set  value  to tagsinput */
    Value:TagsInputDTO[]=null;
    //** Set the MaxLength of characters In AutoComplete */
    MaxLength?: number
    /**Set the MinLength of characters In AutoComplete  */
    MinLength?: number
    //** Set the MaxWordCount of characters In AutoComplete */
    MaxWordCount: number;
    /**Prevent AutoComplete of tagsinput*/
    AutoComplete: boolean
    /**
     * Display "*" beside the label 
     * if ForceAsterisk=true and IsRequired=True his display "*" ,
     * if if ForceAsterisk=false and IsRequired=false this remove "*",
     *if ForceAsterisk=false and IsRequired=True this display "*" , 
      */
    ShowAsterisk: boolean
    /** Ability to set  AutoComplete required */
    IsRequired: boolean
    /** Ability to display or hide the label of AutoComplete */
    HideLabel: boolean
    /** Sets an attribute disable="disabled"  */
    IsDisabled: boolean
    /**  text input on change  */
    TrimTextOnChange: boolean
    /** add button to for coping to clipboard */
    EnableCopyToClipboard: boolean
    /**Prevent  Defulat Password Validation to set Custom Validation */
    RemoveDefulatPasswordValidation: boolean
    /**  to set type of view  if tagsinput is Vertical or Horizontal */
    ViewType:ControlLayout=ControlLayout.Vertical
    /** Allow to Pass Object With Body of Function which represent CustomValidation and massage for error massage 
    */
   CustomValidation: CustomValidation[]=[]
    /** to set Direction of tagsinput  if tagsinput is Arabic or English  */
    ForceDirection: ForceDirection=ForceDirection.English

    /** Set List of Custom Attribute to AutoComplete  */
    AttributeList: Attribute[]
    /**the url of a remote server that supports jsonp calls */
    ActionURL: string;
      /**Remove Last When User Click On Backspace */
    RemoveLastOnBackspace:boolean=false 
   /** Allow User To Delete Tags */
    CanDeleteTags:boolean=true
    /** Allow User To Add Tags */
    CanAddTags:boolean=true
    /** Set Max Number Of Tags That User Can Be Select  */
    MaxNumberTags :number=100
    /** Set Min Length Of Char To Call Search Function   */
    MinSearchLength:number=1
    /**Allow  Scrolle Option In Dropdown  */
    ScrollableOptions:boolean=true
    /** Set Max Number Of Tags That will Be Appear ON Dropdown  */
    MaxSearchResultsCount:number=5
    /**Value Name Of Tag Option In Dropdown */
    DatasourceItemValue :string="key"
    /**Text  Of Tag That Will Show In Dropdown */
    DatasourceItemText:string="value"
    /**Text Show  when none of the given options match the entered text */
    NoResultText:string="No Item Matches"
    /**Set Query Param Name By Default It's 'query'*/
    QueryParamName:string="query"
    /**Set Filter Param Name By Default It's 'query'*/
    FilterParamName:string=""
    DefaultImgUrl:string
     /** allow add  value of  TagInput dosn't exist in list*/
     AllowNewSelection :boolean =false; 
}
